import React, { memo, useEffect } from "react";
import useProduct from "../../../hooks/useProduct";
import ProductItem from "../../Products/components/ProductItem";
import Loader from "../../../components/Loader";

const ProductListWithVideo = memo(() => {
  const { products = [], isLoading, setHasVideo } = useProduct();

  // Ativa o filtro de vídeo quando o componente monta
  useEffect(() => {
    setHasVideo(true);
  }, []); // Executa apenas uma vez na montagem

  return (
    <div className="col-12">
      {isLoading ? (
        <Loader type="pulse" size="medium" />
      ) : products.length === 0 ? (
        <div style={{ textAlign: "center", padding: "40px" }}>
          <h3 style={{ color: "#666" }}>Nenhum produto com vídeo encontrado</h3>
          <p style={{ color: "#999", marginTop: "10px" }}>
            No momento, não há produtos com materiais em vídeo disponíveis.
          </p>
        </div>
      ) : (
        <div className="row">
          {products.map((product) => (
            <ProductItem key={product.id} {...product} />
          ))}
        </div>
      )}
    </div>
  );
});

ProductListWithVideo.displayName = "ProductListWithVideo";
export default ProductListWithVideo;
